export default "__VITE_ASSET__BgX37nGb__"